import { render, staticRenderFns } from "./View.vue?vue&type=template&id=97510ab2&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=97510ab2&prod&lang=scss"
import style1 from "./View.vue?vue&type=style&index=1&id=97510ab2&prod&lang=scss&scoped=true"
import style2 from "./View.vue?vue&type=style&index=2&id=97510ab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97510ab2",
  null
  
)

export default component.exports